<template>
  <div>
    <div class="edit_main">
      <el-form size="mini">
        <el-form-item label="推广平台：">
          <el-radio-group v-model="advertiser.params.type" size="mini" @change="platformChange">
            <el-radio-button v-for="key in channel_interface" :key="key" :label="key">{{ channel_interface_map[key] }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告主列表：">
          <el-button plain size="mini" icon="el-icon-plus" @click="showBatchBox">批量增加</el-button>
          <el-checkbox v-model="show_all_accounts" class="show-all" @change="refreshAdvertiserOptions">显示全部账号</el-checkbox>
          <div v-loading="!advertiser.response[advertiser.params.type].length" class="chose_box">
            <div v-for="key in channel_interface" :key="key">
              <tree-shuttle
                v-if="advertiser.response[`${key}_data`].length && tree_show"
                v-model="platform[key]"
                v-loading="advertiser.loading"
                :title="`${channel_interface_map[key]}广告主`"
                :init-data="advertiser.response[key]"
                :output-data="advertiser.response[`${key}_data`]"
                width="360px"
                :filter-node-method="filterAdvertiser"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span class="footer">
      <el-button size="mini" @click="editCancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="editConfirm">确 定</el-button>
    </span>

    <!-- 批量添加广告主 -->
    <el-dialog
      title="批量添加广告主"
      :visible.sync="batch_box_show"
      width="45%"
      :before-close="closeBatchBox"
      append-to-body
    >
      <bacth-add v-if="batch_box_show" @cancel="closeBatchBox" @config="configBatch" />
    </el-dialog>
  </div>
</template>

<script>
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
import UserResource from '@/api/user';
const userResource = new UserResource();
import TreeShuttle from '@/components/tree-shuttle';
import { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } from '@/enums';
import { transformEnumToObject } from '@/tools';

export default {
  components: {
    'tree-shuttle': TreeShuttle,
    'bacth-add': () => import('./bacth_add'),
  },
  props: {
    // 编辑参数
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tree_show: true,
      batch_box_show: false,
      show_all_accounts: false,
      advertiser: {
        loading: false,
        response: {},
        params: {
          type: CHANNEL_INTERFACE_TYPE.JRTT,
          is_list: true,
          allot: 1,
        },
      },
      edit: {
        init: { name: '' },
        params: {
          id: '',
        },
      },
      // 当前用户已绑定的广告主 - 列表接口已不再返回广告主参数，改为请求「获取用户可操作的广告主」接口
      bound_advertiser: {
        loading: false,
        list: [],
        // 前端暂不支持展示的平台上的绑定，原样保留提交
        unsupported_ids: [],
      },
      platform: {},
      channel_interface: Object.values(CHANNEL_INTERFACE_TYPE).filter(value => value !== CHANNEL_INTERFACE_TYPE.JRTT_V3),
      channel_interface_map: transformEnumToObject(CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT),
    };
  },
  created() {
    this.initData();
    this.edit.params.id = this.data.id;
    // 列表接口已不再返回广告主，先取回已绑定广告主，再拉候选列表，保证绑定项一定在候选池内
    this.getBoundAdvertisers().then(() => this.getMediasList());
  },
  methods: {
    /**
     * 初始化data数据
     * @returns {void}
     */
    initData() {
      this.channel_interface.forEach(key => {
        this.$set(this.advertiser.response, key, []);
        this.$set(this.advertiser.response, `${key}_data`, []);
        this.$set(this.platform, key, []);
      });
    },

    /** 获取当前用户已绑定的广告主，用于回显已选项 */
    async getBoundAdvertisers() {
      this.bound_advertiser.loading = true;
      try {
        const { list = [] } = await userResource.advertisers(this.edit.params.id);
        this.bound_advertiser.list = Array.isArray(list) ? list : [];
        this.classificationFormPlatform(this.bound_advertiser.list);
      } catch (error) {
        console.log(error);
      } finally {
        this.bound_advertiser.loading = false;
      }
    },

    /** 已绑定但不在媒体账号列表中的广告主也要放入候选池，保证回显且提交时不丢数据 */
    withBoundAdvertisers(type, list) {
      const medias = Array.isArray(list) ? list : [];
      const exists = new Set(medias.map(item => item.id));
      const missing = this.bound_advertiser.list
        .filter(item => item.type === type && !exists.has(item.id))
        .map(item => ({
          id: item.id,
          advertiser_id: item.advertiser_id,
          advertiser_name: item.advertiser_name,
        }));
      return [...medias, ...missing];
    },

    // 根据平台获取广告主
    platformChange() {
      this.channel_interface.forEach(key => {
        this.advertiser.response[key] = [];
        this.advertiser.response[`${key}_data`] = [];
      });
      this.getMediasList();
    },

    refreshAdvertiserOptions() {
      const type = this.advertiser.params.type;
      const allData = this.advertiser.response[`${type}_data`] || [];
      this.$set(
        this.advertiser.response,
        type,
        this.show_all_accounts ? allData : allData.filter(item => this.isActiveAccount(item))
      );
      this.updataTree();
    },

    // 完成批量添加广告主
    configBatch(list){
      const _list = [...new Set(list)].filter(item => {
        return item;
      });
      let init_data = [];
      const { type } = this.advertiser.params;
      if (this.isMediaPlatform(type)) {
        init_data = this.advertiser.response[`${type}_data`];
        this.platform[type].push(...this.filterIds(init_data, _list));
        this.platform[type] = [...new Set(this.platform[type])];
      }
      this.closeBatchBox();
      this.updataTree();
    },

    // 通过广告主id 查找资源id
    filterIds(init_data, list){
      return init_data.filter(item => {
        let flag = false;
        list.forEach(e => {
          item.advertiser_id === e || item.advertiser_name === e ? flag = true : '';
        });
        return flag;
      }).map(item => {
        return item.id;
      });
    },

    // 显示批量盒子
    showBatchBox(){
      this.batch_box_show = true;
    },

    // 关闭批量盒子
    closeBatchBox(){
      this.batch_box_show = false;
    },

    // 刷新组件
    updataTree(){
      this.tree_show = false;
      this.$nextTick(() => {
        this.tree_show = true;
      });
    },

    // 根据平台分类
    classificationFormPlatform(list) {
      Object.keys(this.platform).forEach(key => {
        this.platform[key].splice(0);
      });
      this.bound_advertiser.unsupported_ids = [];
      (Array.isArray(list) ? list : []).forEach(({ type, id }) => {
        if (this.isMediaPlatform(type)) {
          this.platform[type].push(id);
        } else {
          // 前端暂不支持展示的平台，保留原有绑定，避免保存时被覆盖删除
          this.bound_advertiser.unsupported_ids.push(id);
        }
      });
    },

    // 获取广告主
    async getMediasList() {
      this.advertiser.loading = true;
      await mediasResource
        .getMediasListApi(this.advertiser.params)
        .then(response => {
          const { type } = this.advertiser.params;
          this.advertiser.response[`${type}_data`] = this.resetAdvertiserList(this.withBoundAdvertisers(type, response.list));
          this.refreshAdvertiserOptions();
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.advertiser.loading = false;
        });
    },

    // 重置广告主列表
    resetAdvertiserList(list) {
      return list.map(item => {
        const status = item.account_status || item.accountStatus || '';
        const _list = {
          id: item.id,
          advertiser_id: item.advertiser_id,
          advertiser_name: item.advertiser_name,
          account_status: status,
          label: status ? `${item.advertiser_name}（${status}）` : item.advertiser_name,
        };
        return _list;
      });
    },

    isActiveAccount(item) {
      return item.account_status === '活跃' || item.account_status === 1;
    },

    // 广告主名称支持模糊匹配，广告主ID仅支持精确匹配
    filterAdvertiser(value, data) {
      if (!value) {
        return true;
      }
      const keyword = String(value);
      const label = data.label == null ? '' : String(data.label);
      const advertiserId = data.advertiser_id == null ? '' : String(data.advertiser_id);
      return label.indexOf(keyword) !== -1 || advertiserId === keyword;
    },

    // 确认编辑
    editConfirm() {
      const { id } = this.edit.params;
      const params = {
        uid: id,
        ids: this.getAllIds(),
      };
      mediasResource
        .assignAdvertiserApi(params)
        .then(response => {
          this.$message.success('修改绑定广告主成功');
          this.$emit('config');
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取所有媒体平台广告主ID
    getAllIds() {
      const ids = [];
      Object.entries(this.platform).forEach(([, value]) => {
        ids.push(...value);
      });
      // 前端未展示平台的原有绑定一并提交，避免被覆盖删除
      ids.push(...this.bound_advertiser.unsupported_ids);
      return ids;
    },

    editCancel() {
      this.$emit('cancel');
    },

    // 是否是媒体平台
    isMediaPlatform(type) {
      return this.channel_interface.includes(type);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-input,
.el-select {
  width: 350px !important;
}
.chose_box{
  margin-left: 95px;
  margin-top: 10px;
}
.show-all {
  margin-left: 10px;
}
.footer {
  display: block;
  text-align: center;
}
</style>
